import React from "react";
import Layout from "../../components/shared/Layout";
import SEO from "../../components/SEO/SEOGame";
import Breadcrumbs from "../../components/shared/Breadcrumbs";
import FreespinGame from "../../components/Content/Freespin/FreespinGame";
import LoadmoreComments from "../../components/Content/Freespin/Comments/LoadmoreCommentsGame";
import "../../assets/styles/pages/game.scss";

const Game = ({ pageContext }) => {
  const { metaTitle, metaDescription, gameCode, gameName, breadcrumbs, pagePath } = pageContext;
  const ratingValue = (5 - Math.random()).toFixed(2);
  const ratingCount = "" + Math.floor(Math.random() * 1000);
  const seoBreadcrumbs = [{ url: "/game/" + gameCode + "/", text: gameName}];

  return (
    <Layout>
      <SEO
        title={metaTitle}
        description={metaDescription ||
        `ล็อคอิน เล่นเกมฟรีๆ กับฟรีสปินที่ สโบท็อป-ไทย.com - เกม ${gameName}`}
        uri={'/game/' + gameCode + '/'}
        breadcrumbs={seoBreadcrumbs}
        gameTitle={gameName}
        gameRating={ratingValue}
        gameRatingVotes={ratingCount}
      />
      <Breadcrumbs breadcrumbs={breadcrumbs} pageUrl={pagePath} />
      <div className="hentry">
        <div className="wrapper">
          <FreespinGame h1={gameName} gameName={gameName} gameCode={gameCode}/>
        </div>
        <LoadmoreComments/>
      </div>
    </Layout>
  );
};

export default Game;
